import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { copy } from "@/content";

const BG_IMG =
  "https://images.pexels.com/photos/15757999/pexels-photo-15757999.jpeg";

const PILLARS = [
  { tag: "01", title: "STRATEGY" },
  { tag: "02", title: "ACCESS" },
  { tag: "03", title: "NEGOTIATION" },
];

export const Philosophy = ({ lang = "en" }) => {
  const t = copy[lang].philosophy;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="about"
      ref={ref}
      className="relative overflow-hidden py-28 sm:py-40"
      data-testid="philosophy-section"
    >
      <motion.div
        style={{ y: bgY }}
        aria-hidden="true"
        className="absolute inset-y-[-10%] right-0 hidden w-[45%] opacity-20 lg:block"
      >
        <div
          className="h-full w-full"
          style={{
            backgroundImage: `url(${BG_IMG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            WebkitMaskImage:
              "linear-gradient(to right, transparent 0%, black 55%)",
            maskImage: "linear-gradient(to right, transparent 0%, black 55%)",
          }}
        />
      </motion.div>

      <div className="relative mx-auto max-w-[1600px] px-6 sm:px-10">
        <Reveal>
          <p className="dealer-eyebrow" data-testid="philosophy-eyebrow">
            PHILOSOPHY
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-4xl font-serif text-3xl leading-[1.15] tracking-tight text-dealer-ivory sm:text-4xl lg:text-5xl">
            CREATING
            <br />
            <span className="text-dealer-burgundybright">WHAT ISN&rsquo;T</span>
            <br />
            THERE YET.
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-12 max-w-xl text-sm font-light leading-relaxed text-dealer-silver sm:text-base">
            {t.body}
          </p>
        </Reveal>

        <div className="mt-20 grid gap-px bg-dealer-ivory/10 sm:grid-cols-3">
          {PILLARS.map((p, i) => (
            <Reveal key={p.tag} delay={0.1 + i * 0.1} className="bg-dealer-black">
              <div
                className="group h-full px-2 py-10 sm:px-8"
                data-testid={`philosophy-pillar-${p.tag}`}
              >
                <span className="font-serif text-sm italic text-dealer-burgundybright">
                  {p.tag}
                </span>
                <h3 className="mt-4 font-serif text-xl tracking-[0.08em] text-dealer-ivory sm:text-2xl">
                  {p.title}
                </h3>
                <span className="mt-6 block h-px w-10 bg-dealer-ivory/20 transition-[width] duration-700 group-hover:w-20" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
